import { Dropdown } from 'antd';
import React, { useEffect, useState } from 'react';
import { getCalendarSup } from '../utils';

const styles = {
    container: {
        width: '100%',
        padding: '20px',
        borderRadius: '12px',
        backgroundColor: 'white',
        textAlign: 'center',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    title: {
        fontSize: '18px',
        fontWeight: 'bold',
    },
    arrowButton: {
        background: 'none',
        border: 'none',
        fontSize: '18px',
        cursor: 'pointer',
    },
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(7, 1fr)',
        gap: '10px',
        marginTop: '20px',
    },
    dayButton: {
        padding: '10px',
        fontSize: '16px',
        border: 'none',
        cursor: 'pointer',
        borderRadius: '6px',
        transition: 'background-color 0.3s',
    },
    footer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '20px',
    },
    cancelButton: {
        padding: '10px 20px',
        fontSize: '16px',
        color: '#555',
        backgroundColor: '#f0f0f0',
        border: '1px solid #ddd',
        borderRadius: '6px',
        cursor: 'pointer',
    },
    applyButton: {
        padding: '10px 20px',
        fontSize: '16px',
        border: 'none',
        borderRadius: '6px',
        cursor: 'pointer',
    },
};

const CalendarPicker = ({ handleContributionDay, dateValue }) => {
    const [selectedDay, setSelectedDay] = useState(null);
    const [open, setopen] = useState(false);

    const daysInMonth = Array.from({ length: 30 }, (_, i) => i + 1);

    function handleOpenChange() {
        setopen(!open);
    }

    const handleDayClick = (day) => {
        setSelectedDay(day);
    };

    const handleCancel = async () => {
        await handleContributionDay('');
        await setopen(false);
        await setSelectedDay(null);
    };

    const handleApply = async () => {
        await handleContributionDay(`On ${getCalendarSup(selectedDay)}`);
        await setopen(false);
        await setSelectedDay(null);
    };

    const calendarItems = [
        {
            label: (
                <div style={styles.container}>
                    <div style={styles.header}>
                        <button type="button" style={styles.arrowButton}>
                            ←
                        </button>
                        <h2 style={styles.title}>Select day of the month</h2>
                        <button type="button" style={styles.arrowButton}>
                            →
                        </button>
                    </div>

                    <div style={styles.grid}>
                        {daysInMonth.map((day) => (
                            <button
                                type="button"
                                key={day}
                                onClick={() => handleDayClick(day)}
                                style={{
                                    ...styles.dayButton,
                                    backgroundColor: day === selectedDay ? '#FFC107' : 'transparent',
                                }}
                            >
                                {day}
                            </button>
                        ))}
                    </div>

                    <div style={styles.footer}>
                        <button type="button" style={styles.cancelButton} onClick={handleCancel}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            style={{
                                ...styles.applyButton,
                                backgroundColor: selectedDay ? '#FFC107' : '#f0f0f0',
                                color: selectedDay ? 'black' : '#ccc',
                            }}
                            onClick={handleApply}
                            disabled={!selectedDay}
                        >
                            Apply
                        </button>
                    </div>
                </div>
            ),
        },
    ];

    return (
        <Dropdown
            overlayClassName="avatar_dropdown"
            onOpenChange={handleOpenChange}
            arrow
            open={open}
            menu={{
                items: calendarItems,
            }}
            trigger={['click']}
            placement="bottom"
        >
            <button type="button">{dateValue?.length ? dateValue : 'Choose date'}</button>
        </Dropdown>
    );
};

export default CalendarPicker;
